import React, { useEffect, useState } from "react";
import { AuthLoader } from "../auth/authProvider";
import { useFluidFormConfigClient } from "../formBuilder/fluidFormConfig.client";
import { PageError } from "../components/PageError";
export function ExampleAuthWrapper({ formConfig, children }) {
    return (React.createElement(AuthLoader, null,
        React.createElement(ConfigSaver, { formConfig: formConfig, children: children })));
}
function ConfigSaver({ formConfig, children }) {
    let formConfigClient = useFluidFormConfigClient();
    const [error, setError] = useState(null);
    useEffect(() => {
        console.log('Saving form config', formConfig);
        /*
          We need to save the Form Config for the AI features to work, as the backend does a security check agains the
          existing configuration.
          This call with only work if the user is authenticated and has the necessary permissions.
        */
        formConfigClient.saveFormConfig({
            formConfig: formConfig,
            formKey: formConfig.key,
            label: formConfig.label
        }).then(async () => {
            try {
                await formConfigClient.publishForm(formConfig.key);
            }
            catch (err) {
                setError("Failed to load form config. Please refresh the page and try again.");
            }
        }).catch((err) => {
            setError("Failed to load form config. Please refresh the page and try again.");
        });
    }, []);
    if (error) {
        return React.createElement(PageError, { title: "Error Initializing Form", error: error });
    }
    return children;
}
